import { LifetimeCostsChartTabParams } from '../models/chart/LifetimeCostsChartTabParams';
import { DEFAULT_LIFETIME_NUMBER_OF_YEARS } from './DefaultLifetimeNumberOfYears';

export const DEFAULT_LIFETIME_COST_CHART_TAB_PARAMS: LifetimeCostsChartTabParams = {
    lifetimeNumberOfYears: DEFAULT_LIFETIME_NUMBER_OF_YEARS,
    lifetimeNumberOfYearsString: DEFAULT_LIFETIME_NUMBER_OF_YEARS.toString(),
    lifetimeNumberOfYearsUserInput: false,
    showSavings: false
};
